import { required } from './required';
var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export function validateEmail(value) {
    return !value || (!value.endsWith('@yopmail.com') && regex.test(value))
        ? null
        : 'Enter a valid email address';
}
export var requiredEmail = required(validateEmail);
//# sourceMappingURL=validateEmail.js.map